<template>
  <div class="wrap">
    <div class="flex_box margin-bottom20">
      <div class="postiverelatibve">
        <img :src="imageUrl" v-if="imageUrl" class="avatar" />
        <div v-else class="avatar avatartex" style="overflow: hidden">
          {{ userInfo?.userInfo?.firstName }}
        </div>
        <img
          v-if="userInfo?.lockType == 1"
          src="../../../assets/img/vip.png"
          class="postiveaboust"
        />
        <img
          v-if="userInfo?.lockType == 2"
          src="../../../assets/img/jinvip.png"
          class="postiveaboust"
        />
      </div>
      <div class="account-left-right">
        <h3>
          {{ userInfo?.userInfo?.firstName }} {{ userInfo?.userInfo?.lastName }}
        </h3>
        <h4 v-if="userInfo?.userInfo?.userType == '1'">
          {{ $t("navigationBar.IndivdualAccount") }}
        </h4>
        <h4 v-else>
          {{ $t("navigationBar.GroupAccount") }}
        </h4>
      </div>
    </div>
    <div class="left_menu_input margin-bottom20">
      <!-- autocomplete="off" -->
      <el-input
        v-model="input"
        prefix-icon="el-icon-search"
        type="text"
        :placeholder="$t('AccountCenterMenu.SearchinSettings')"
        @input="menuchange"
      ></el-input>
    </div>
    <div class="left_menu">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical-demo"
        @select="selectopen"
        :unique-opened="true"
        @open="handleOpen"
        icon="el-icon-caret-right"
        background-color="#F5F5F5"
        active-text-color="#1290C9"
      >
        <el-submenu
          v-for="(item, index) in menuItems"
          :key="index"
          :index="item.index"
          v-show="item.isShow"
          :class="
            item.screenName == 'Billing and Payment' &&
            item.hasPrivilege == false
              ? 'buttonhui'
              : ''
          "
          :disabled="!item.hasPrivilege"
        >
          <template slot="title">
            <i
              class="el-icon-caret-right"
              v-if="
                item.index == '/account/UserSettings' ||
                item.index == '/account/About'
              "
              style="opacity: 0"
            ></i>
            <i class="el-icon-caret-right" v-else></i>

            <svg
              v-if="item.index == 0"
              t="1723629044985"
              class="icon iconBgwidthMagin"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5445"
            >
              <path
                d="M899.64 897.715c-7.238-108.133-60.68-208.738-146.61-276.032l-5.165-3.568-0.047 0.07c-4.887-2.989-10.458-4.587-16.193-4.587-19.702 0-31.458 9.498-31.458 25.412 0 9.266 4.285 17.975 11.477 23.883l-0.08 0.139 4.562 3.266c72.065 51.519 112.638 129.653 120.584 232.273l0.085 1.12a31.507 31.507 0 0 0-0.116 2.612c0 17.341 14.058 31.4 31.4 31.4 16.76 0 30.45-13.13 31.35-29.665h0.624l-0.412-6.323z m-101.124-525.92c0-156.107-128.53-283.118-286.525-283.118S225.465 215.688 225.465 371.796c0 84.11 37.191 162.57 102.378 216.66-117.017 62.453-194.688 181.59-203.48 313.119l-0.362 5.483c-0.007 0.113-0.016 0.226-0.022 0.34l-0.033 0.5h0.02c-0.009 0.267-0.02 0.533-0.02 0.802 0 14.703 11.918 26.622 26.622 26.622 14.703 0 26.623-11.918 26.623-26.622 0-0.27-0.013-0.535-0.02-0.802h0.554l0.417-5.468c9.648-124.998 88.871-234.45 202.112-279.553 33.81 15.706 85.42 32.06 131.715 32.06 42.89 0 84.54-9.45 124.199-28.307l29.049-16.863 23.72-15.567c69.63-54.203 109.579-135.28 109.579-222.404zM511.99 597.932c-126.248 0-228.95-101.462-228.95-226.158 0-124.673 102.701-226.112 228.95-226.112 126.26 0 228.973 101.439 228.973 226.112-0.001 124.696-102.714 226.158-228.973 226.158z"
                p-id="5446"
                :fill="$route.meta.father == 'Account' ? '#1296db' : '#1A2332'"
              ></path>
            </svg>

            <svg
              v-if="item.index == 1"
              t="1723629413656"
              class="icon iconBgwidth"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6188"
              id="mx_n_1723629413658"
            >
              <path
                d="M85.333333 34.133333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V68.266667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V68.266667a68.266667 68.266667 0 0 1 68.266666-68.266667z m119.466667 136.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333-324.266667a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m0 392.533333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4z m-136.533333 392.533333a17.066667 17.066667 0 1 0 0 34.133334 17.066667 17.066667 0 0 0 0-34.133334z m0-34.133333a51.2 51.2 0 1 1 0 102.4 51.2 51.2 0 0 1 0-102.4z m136.533333 34.133333a17.066667 17.066667 0 1 0 0 34.133334h170.666667a17.066667 17.066667 0 1 0 0-34.133334H341.333333z m0-34.133333h170.666667a51.2 51.2 0 0 1 0 102.4H341.333333a51.2 51.2 0 0 1 0-102.4zM85.333333 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V426.666667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V426.666667a68.266667 68.266667 0 0 1 68.266666-68.266667z m0 392.533333a34.133333 34.133333 0 0 0-34.133333 34.133334v170.666666a34.133333 34.133333 0 0 0 34.133333 34.133334h853.333334a34.133333 34.133333 0 0 0 34.133333-34.133334V785.066667a34.133333 34.133333 0 0 0-34.133333-34.133334H85.333333z m0-34.133333h853.333334a68.266667 68.266667 0 0 1 68.266666 68.266667v170.666666a68.266667 68.266667 0 0 1-68.266666 68.266667H85.333333a68.266667 68.266667 0 0 1-68.266666-68.266667V785.066667a68.266667 68.266667 0 0 1 68.266666-68.266667z"
                :fill="$route.meta.father == 'Database' ? '#1296db' : '#1A2332'"
                p-id="6189"
              ></path>
            </svg>

            <svg
              v-if="item.index == 2"
              slot="reference"
              id="id1wIih1"
              class="icon"
              t="1708929823979"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="18274"
            >
              <path
                id="idCG1WrO"
                d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                p-id="5361"
                :fill="
                  $route.meta.father == 'Organizational' ? '#1296db' : '#1A2332'
                "
              ></path>
              <path
                id="idrrFDpK"
                d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                p-id="5362"
                :fill="
                  $route.meta.father == 'Organizational' ? '#1296db' : '#1A2332'
                "
              ></path>
            </svg>
            <svg
              v-if="item.index == 3"
              t="1723629515493"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6496"
            >
              <path
                d="M512 896c212.078933 0 384-171.921067 384-384s-171.921067-384-384-384-384 171.921067-384 384 171.921067 384 384 384z m0 42.666667c-235.639467 0-426.666667-191.0272-426.666667-426.666667S276.360533 85.333333 512 85.333333s426.666667 191.0272 426.666667 426.666667-191.0272 426.666667-426.666667 426.666667z"
                :fill="$route.meta.father == 'Billing' ? '#1296db' : '#1A2332'"
                p-id="6497"
              ></path>
              <path
                d="M512 797.866667c157.879467 0 285.866667-127.9872 285.866667-285.866667s-127.9872-285.866667-285.866667-285.866667-285.866667 127.9872-285.866667 285.866667 127.9872 285.866667 285.866667 285.866667z m0 42.666666c-181.444267 0-328.533333-147.089067-328.533333-328.533333s147.089067-328.533333 328.533333-328.533333 328.533333 147.089067 328.533333 328.533333-147.089067 328.533333-328.533333 328.533333z"
                :fill="$route.meta.father == 'Billing' ? '#1296db' : '#1A2332'"
                p-id="6498"
              ></path>
              <path
                d="M533.333333 683.968c41.365333-10.346667 72.644267-47.044267 74.210134-91.7888 1.890133-54.161067-40.4864-99.605333-94.651734-101.495467a21.589333 21.589333 0 0 0-2.133333 0.029867 21.589333 21.589333 0 0 0-2.129067-0.1792c-28.258133-0.989867-50.368-24.695467-49.3824-52.957867 0.9856-28.258133 24.695467-50.368 52.957867-49.3824 28.258133 0.989867 50.368 24.695467 49.378133 52.957867a21.333333 21.333333 0 0 0 42.641067 1.489067c1.578667-45.047467-28.864-83.7888-70.890667-94.3232V328.533333a21.333333 21.333333 0 1 0-42.666666 0v19.042134c-41.088 8.8064-72.5248 44.612267-74.0608 88.512-1.809067 51.810133 38.724267 95.274667 90.5344 97.088 0.721067 0.0256 1.4336 0.0128 2.133333-0.034134 0.699733 0.093867 1.408 0.157867 2.133333 0.183467 30.613333 1.066667 54.562133 26.752 53.495467 57.365333-1.066667 30.6176-26.752 54.570667-57.3696 53.499734-30.613333-1.066667-54.5664-26.752-53.495467-57.3696a21.333333 21.333333 0 1 0-42.641066-1.489067c-1.706667 48.917333 32.6912 90.722133 79.2704 99.754667V704a21.333333 21.333333 0 1 0 42.666666 0v-20.032z"
                :fill="$route.meta.father == 'Billing' ? '#1296db' : '#1A2332'"
                p-id="6499"
              ></path>
            </svg>
            <svg
              v-if="item.index == '/account/UserSettings'"
              t="1723629551105"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="6733"
            >
              <path
                d="M942.08 519.68c0-33.28-2.56-61.44-10.24-81.92 2.56-20.48-10.24-35.84-30.72-40.96h-2.56c-35.84-7.68-61.44-25.6-81.92-61.44-17.92-30.72-23.04-66.56-10.24-99.84 7.68-15.36 2.56-35.84-12.8-48.64-38.4-35.84-87.04-64-140.8-81.92-15.36-7.68-35.84-2.56-48.64 12.8-23.04 28.16-56.32 43.52-94.72 43.52-33.28 0-66.56-15.36-94.72-43.52-17.92-17.92-35.84-15.36-48.64-12.8-56.32 20.48-99.84 46.08-135.68 79.36-17.92 10.24-23.04 30.72-15.36 46.08 10.24 38.4 7.68 74.24-10.24 104.96-15.36 30.72-46.08 51.2-81.92 61.44-2.56 0-5.12 0-5.12 2.56-12.8 7.68-23.04 17.92-25.6 30.72v2.56c-5.12 28.16-10.24 53.76-10.24 84.48 0 33.28 2.56 61.44 10.24 81.92-2.56 15.36 5.12 30.72 28.16 40.96h2.56c35.84 7.68 61.44 25.6 81.92 61.44 17.92 30.72 23.04 66.56 10.24 99.84-7.68 15.36-2.56 35.84 12.8 48.64 35.84 33.28 84.48 64 140.8 84.48h2.56c2.56 0 2.56 2.56 5.12 2.56h5.12c12.8 0 25.6-5.12 35.84-15.36 23.04-28.16 56.32-43.52 94.72-43.52 33.28 0 66.56 15.36 94.72 43.52 10.24 10.24 20.48 15.36 33.28 15.36 5.12 0 12.8 0 17.92-2.56 58.88-23.04 99.84-48.64 138.24-81.92 15.36-10.24 23.04-30.72 15.36-46.08-10.24-38.4-7.68-74.24 10.24-104.96 15.36-30.72 46.08-51.2 81.92-61.44 2.56 0 5.12 0 5.12-2.56 12.8-7.68 23.04-17.92 25.6-30.72v-2.56c5.12-28.16 7.68-56.32 7.68-84.48zM140.8 445.44c48.64-12.8 89.6-43.52 112.64-84.48 23.04-43.52 30.72-92.16 17.92-140.8 33.28-28.16 71.68-51.2 117.76-69.12 38.4 35.84 81.92 56.32 130.56 56.32 51.2 0 99.84-20.48 130.56-56.32 43.52 15.36 81.92 38.4 115.2 69.12-12.8 51.2-7.68 99.84 17.92 140.8 23.04 43.52 61.44 74.24 110.08 87.04 5.12 20.48 7.68 46.08 7.68 71.68 0 20.48-2.56 40.96-7.68 69.12-51.2 15.36-89.6 46.08-110.08 87.04-23.04 43.52-30.72 92.16-17.92 140.8-33.28 28.16-71.68 51.2-117.76 69.12-38.4-35.84-84.48-53.76-130.56-53.76-51.2 0-97.28 20.48-130.56 56.32-43.52-15.36-81.92-38.4-115.2-69.12 12.8-51.2 7.68-99.84-17.92-140.8-23.04-43.52-61.44-74.24-110.08-87.04-5.12-20.48-7.68-48.64-7.68-71.68-2.56-25.6 0-46.08 5.12-74.24z"
                p-id="6734"
                :fill="
                  $route.meta.father == 'UserSettings' ? '#1296db' : '#1A2332'
                "
              ></path>
              <path
                d="M670.72 463.36c-5.12-12.8-17.92-20.48-30.72-17.92-12.8 5.12-20.48 20.48-15.36 33.28 7.68 20.48 7.68 46.08 0 74.24-10.24 28.16-30.72 51.2-56.32 66.56-28.16 12.8-58.88 15.36-87.04 5.12-28.16-10.24-51.2-30.72-66.56-56.32-12.8-28.16-15.36-58.88-5.12-87.04 10.24-28.16 30.72-51.2 56.32-66.56 28.16-12.8 58.88-15.36 87.04-5.12 12.8 5.12 28.16-2.56 33.28-15.36 5.12-12.8-2.56-28.16-15.36-33.28-40.96-15.36-87.04-12.8-128 7.68s-71.68 53.76-84.48 94.72c-15.36 40.96-12.8 87.04 7.68 128s53.76 71.68 94.72 84.48c15.36 5.12 35.84 10.24 53.76 10.24 71.68 0 133.12-46.08 156.16-112.64 10.24-38.4 10.24-74.24 0-110.08z"
                p-id="6735"
                :fill="
                  $route.meta.father == 'UserSettings' ? '#1296db' : '#1A2332'
                "
              ></path>
            </svg>
            <svg
              v-if="item.index == 5"
              t="1723629718161"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5982"
            >
              <path
                d="M506.550742 1024h-3.232833a242.46251 242.46251 0 0 1-173.225993-75.702184 26.940279 26.940279 0 1 1 39.063404-37.177584A188.581952 188.581952 0 0 0 645.023776 909.773218 26.940279 26.940279 0 0 1 684.895388 945.873191a244.078927 244.078927 0 0 1-178.344646 78.126809zM900.956425 834.879242h-781.268087a94.290976 94.290976 0 0 1 0-188.581952 13.739542 13.739542 0 0 0 13.739542-13.470139v-255.663247a377.163904 377.163904 0 0 1 754.327808 0v255.663247a13.739542 13.739542 0 0 0 13.739542 13.470139 94.290976 94.290976 0 0 1 0 188.581952zM510.322381 56.843988A323.283346 323.283346 0 0 0 187.039035 377.163904v255.663247a67.6201 67.6201 0 0 1-67.6201 67.350697 40.410418 40.410418 0 0 0 0 80.820837h781.268087a40.410418 40.410418 0 0 0 0-80.820837 67.6201 67.6201 0 0 1-67.081294-67.350697v-255.663247A323.283346 323.283346 0 0 0 510.322381 56.843988z"
                :fill="
                  $route.meta.father == 'Notifications' ? '#1296db' : '#1A2332'
                "
                p-id="5983"
              ></path>
            </svg>
            <svg
              v-if="item.index == 6"
              t="1723629649378"
              class="icon"
              viewBox="0 0 1059 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5451"
            >
              <path
                d="M547.326184 788.934951m-54.851338 0a54.851338 54.851338 0 1 0 109.702676 0 54.851338 54.851338 0 1 0-109.702676 0Z"
                p-id="5452"
                fill="#1A2332"
              ></path>
              <path
                d="M547.326184 184.213435c-100.826964 0-182.856638 81.294743-182.856638 181.217175a36.576981 36.576981 0 0 0 73.153962 0c0-60.603591 48.194554-108.063213 109.702676-108.063213 60.490525 0 109.71681 49.59375 109.716809 110.550674 0 24.394076-30.612728 54.964405-60.193725 84.587802-40.378839 40.336439-86.085932 86.043532-86.085932 145.883925v61.847321a36.576981 36.576981 0 1 0 73.139829 0v-61.889721c0-29.510331 32.84579-62.356121 64.659848-94.08538 40.110306-40.124439 81.619809-81.591542 81.619809-136.343947 0-101.307496-82.029674-183.704636-182.856638-183.704636z"
                p-id="5453"
                :fill="$route.meta.father == 'Help' ? '#1296db' : '#1A2332'"
              ></path>
              <path
                d="M547.326184 0C264.999379 0 35.333251 229.666128 35.333251 511.992933a509.10974 509.10974 0 0 0 90.241121 289.972921L6.656784 967.071067A35.333251 35.333251 0 0 0 35.333251 1023.038936l466.031441-0.183733v0.268532c15.687963 0.240266 30.471395 0.862131 45.961492 0.862132 282.326805 0 512.007067-229.666128 512.007067-511.992934S829.667122 0 547.326184 0z m11.377307 950.379639l-4.395457 0.0848c-2.317861 0-5.215188 0.282666-7.547182 0.409866-17.313293 0.890398-29.67993 1.158931-45.39616 1.045864v0.282666l-397.018537 0.1696 95.187777-132.146357a35.333251 35.333251 0 0 0-3.476792-45.424427l0.240267-0.2544a436.238444 436.238444 0 0 1-87.485129-262.526051C108.812278 270.214567 305.533684 73.493161 547.340317 73.493161s438.513906 196.693139 438.513906 438.499772c0 237.976509-190.61582 432.32352-427.150732 438.386706z"
                p-id="5454"
                :fill="$route.meta.father == 'Help' ? '#1296db' : '#1A2332'"
              ></path>
            </svg>
            <svg
              v-if="item.index == '/account/About'"
              t="1724234692735"
              class="icon"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              p-id="5608"
            >
              <path
                d="M700.472 624.178c-34.774-34.774-75.275-62.079-120.379-81.156a377.62 377.62 0 0 0-40.215-14.395c18.671-10.183 35.995-23.096 51.453-38.554 42.382-42.382 65.723-98.731 65.723-158.668s-23.341-116.286-65.723-158.668c-42.381-42.381-98.73-65.722-158.667-65.722s-116.287 23.341-158.668 65.722c-42.382 42.382-65.723 98.731-65.723 158.668s23.341 116.287 65.723 158.668c15.458 15.458 32.782 28.371 51.453 38.554a377.4 377.4 0 0 0-40.215 14.395c-45.103 19.077-85.604 46.382-120.378 81.156-34.775 34.774-62.08 75.276-81.157 120.379-19.756 46.709-29.773 96.312-29.773 147.43 0 13.808 11.193 25 25 25s25-11.192 25-25c0-181.267 147.471-328.738 328.738-328.738 181.266 0 328.738 147.472 328.738 328.738 0 13.808 11.193 25 25 25s25-11.192 25-25c0-51.118-10.018-100.721-29.773-147.43-19.078-45.103-46.383-85.605-81.157-120.379zM258.273 331.404c0-96.159 78.231-174.39 174.391-174.39 96.159 0 174.39 78.231 174.39 174.39s-78.231 174.391-174.39 174.391c-96.16 0-174.391-78.232-174.391-174.391z"
                p-id="5609"
                :fill="$route.meta.father == 'About' ? '#1296db' : '#1A2332'"
              ></path>
              <path
                d="M949.595 723.902c-15.027-41.062-37.593-78.38-67.072-110.92-29.479-32.54-64.394-58.672-103.775-77.67a337.59 337.59 0 0 0-28.944-12.317c14.958-7.855 29.021-17.659 41.87-29.301 39.892-36.138 63.322-85.648 65.976-139.409 2.654-53.761-15.787-105.338-51.925-145.229-36.139-39.891-85.648-63.322-139.41-65.976-13.783-0.672-25.521 9.947-26.202 23.737-0.681 13.79 9.947 25.521 23.737 26.202 40.422 1.995 77.647 19.612 104.819 49.605 27.172 29.993 41.037 68.772 39.041 109.194-1.995 40.422-19.611 77.647-49.604 104.819-28.099 25.455-63.902 39.232-101.549 39.23-2.539 0-5.093-0.063-7.646-0.189-13.786-0.677-25.521 9.947-26.202 23.737a25.25 25.25 0 0 0 0.061 3.307 25.096 25.096 0 0 0-0.386 3.283c-0.681 13.79 9.947 25.521 23.737 26.202 76.875 3.795 147.671 37.299 199.347 94.341s78.045 130.793 74.25 207.668c-0.681 13.79 9.947 25.521 23.737 26.202 0.42 0.021 0.837 0.031 1.253 0.031 13.24 0 24.289-10.398 24.949-23.769 2.249-45.579-4.501-90.253-20.062-132.778z"
                p-id="5610"
                :fill="$route.meta.father == 'About' ? '#1296db' : '#1A2332'"
              ></path>
            </svg>
            <span
              v-if="
                ($route.meta.father == 'UserSettings' &&
                  item.screenName == $t('AccountCenterMenu.UserSettings')) ||
                ($route.meta.father == 'About' &&
                  item.screenName == $t('AccountCenterMenu.AboutCSI'))
              "
              class="activeColor"
              >{{ item.screenName }}</span
            >
            <el-tooltip
              v-else
              class="item"
              :disabled="item.hasPrivilege"
              effect="dark"
              content="Your permission cannot browse this content. Click button to upgrade your permission"
              placement="top"
            >
              <span>{{ item.screenName }}</span>
            </el-tooltip>
          </template>
          <el-menu-item-group v-if="item.children.length > 0">
            <el-menu-item
              :index="ite.index"
              v-for="(ite, inde) in item.children"
              :disabled="!ite.hasPrivilege"
              :key="inde"
              v-show="ite.isShow"
            >
              <el-tooltip
                class="item"
                :disabled="ite.hasPrivilege"
                effect="dark"
                content="Your permission cannot browse this content. Click button to upgrade your permission"
                placement="top"
              >
                <span>{{ ite.screenName }}</span>
              </el-tooltip>
            </el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
  </div>
</template>
<script>
import {
  getUserActionLogPage,
  searchUserCenterMenuList,
  getUserCenterMenuList,
} from "@/api/userApi";
export default {
  props: {
    menuInfos: {
      type: Array,
    },
  },
  data() {
    return {
      linkActive: -1,
      keypadthindex: -1,
      menuTitleList: [],
      input: "",
      menuItemsAll: [],
      activeMenu: "1-1", // 默认选中的菜单项
      menuItems: [],
      userInfo: JSON.parse(localStorage.getItem("userInfo"))
        ? JSON.parse(localStorage.getItem("userInfo"))
        : null,
      list: [],
      list2: [],
      curlinkActive: -1,
      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
    };
  },
  // 监听,当路由发生变化的时候执行
  watch: {
    "$i18n.locale": {
      handler(newVal, oldVal) {
        this.getUserCenterMenuListDate();
      },
      deep: true, // 深度监听，可以监听对象内部属性的变化
      immediate: true, // 立即执行一次handler函数，即使columns没有变化
    },
    $route: "getPath",
    menuInfos: {
      handler(newVal) {
        if (newVal.length > 0) {
          this.list = newVal;
          // this.getMenu();
        }
      },
    },

    curlinkActive: {
      handler(newVal) {
        if (newVal == 0) {
          this.linkClick();
        }
      },
    },
  },

  mounted() {
    this.imageUrl =
      JSON.parse(localStorage.getItem("userInfoImg")) == undefined
        ? this.imageUrl
        : JSON.parse(localStorage.getItem("userInfoImg"));
  },

  created() {
    this.getPath();
    this.$bus.$on("changeImageUrl", (url) => {
      this.imageUrl = url;
    });
  },

  methods: {
    menuchange() {
      let filteredData = this.menuItemsAll.filter((item) =>
        item.screenName.toLowerCase().includes(this.input.toLowerCase()),
      );

      this.menuItems = filteredData;
    },
    getUserCenterMenuListDate() {
      getUserCenterMenuList().then((res) => {
        if (res.code == 200) {
          this.menuItems = res.data;
          this.menuItems.map((item, inex) => {
            if (item.screenName == this.$t("AccountCenterMenu.UserSettings")) {
              this.menuItems[inex].index = "/account/UserSettings";
            }
            if (item.screenName == this.$t("AccountCenterMenu.AboutCSI")) {
              this.menuItems[inex].index = "/account/About";
            }
            if (item.screenName == this.$t("AccountCenterMenu.MyDatabase")) {
              item.children.push({
                index: "/account/industryAnalysis",
                screenName: "Data Analysis",
                hasPrivilege: true,
                isShow: true,
              });
              item.children.push({
                index: "/account/enterpriseAnalysis",
                screenName: "Data Analysis",
                hasPrivilege: true,
                isShow: false,
              });
              const reportScreen = item.children.find(
                (child) => child.screenName === "Reports Downloaded",
              );
              reportScreen.isShow = false;
            }
            if (item.screenName == this.$t("AccountCenterMenu.HelpCenter")) {
              const childItem = item.children.find(
                (child) => child.screenName === "User Guide",
              );
              childItem.isShow = false;
            }
          });
          this.menuItemsAll = this.menuItems;
        } else {
          this.menuItems = [];
        }
      });
    },
    selectopen(key, keyPath) {
      if (key == "/account/companiesViewed") {
        this.$router.push({
          path: key,
          query: { keyword: this.$route.query.keyword, type: "1" },
        });
      } else {
        if (this.$route.query.keword) {
          this.$router.push(key + "?keword=" + this.$route.query.keword);
        } else {
          this.$router.push(key);
        }
      }
      this.keypadthindex = keyPath[0];
    },
    handleOpen(key, keyPath, index) {
      if (key == "/account/About" || key == "/account/UserSettings") {
        this.$router.push(key + "?keword=" + this.$route.query.keword);
      } else {
      }
    },
    handleClose(key, keyPath, index) {},
    //折叠面板
    showSubMenu(el, index) {
      if (el.disBol == false) {
        el.disBol = true;
        return;
      }
      if (el.disBol == true) {
        el.disBol = false;
        return;
      }
    },
    //当路由发生变化的时候执行
    getPath() {
      const route = this.$route.path;

      if (
        route != "/account/companiesViewed" &&
        route != "/account/enterpriseAnalysis"
      ) {
        this.$store.dispatch("app/setTools", {
          name: "menu",
          key: "isActive",
          value: false,
        });
        this.$store.dispatch("app/setTools", {
          name: "select",
          key: "isActive",
          value: false,
        });
      }

      const name = route.split("/account/")[1];
      if (name == "myTag" || name == "portfolio") {
        this.linkActive = 3;
      } else if (
        name == "contactInformation" ||
        name == "alternateContacts" ||
        name == "accountSettings"
      ) {
        this.linkActive = 4;
      }
    },

    linkClick() {
      this.$emit("getCurLink", this.curlinkActive);
    },
  },
};
</script>

<style scoped>
.wrap {
  width: 350px;
  background: #f5f5f5;
  position: fixed;
  left: 0px;
  overflow-y: auto;
  padding: 10px 30px 0px 20px;
}
.flex_box {
  overflow: hidden;
  justify-content: flex-start;
  gap: 20px;
}
.avatar {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  display: block;
}
.avatartex {
  width: 60px;
  height: 60px;
  background: #f5f5f5;
  font-size: 26px;
  color: #a2a9b0;
  text-align: center;
  line-height: 60px;
}

.postiverelatibve {
  position: relative;
}

.postiveaboust {
  position: absolute;
  right: -14px;
  top: 40px;
  z-index: 999;
}

.account-left-right h3 {
  width: 220px;
  font-size: 20px;
  color: #1a2332;
  line-height: 30px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  padding-top: 0;
}
.account-left-right h4 {
  font-size: 16px;
  color: #666666;
  line-height: 22px;
}
.left_menu_input {
  width: 100%;
}
.left_menu_input /deep/ .el-input__prefix {
  font-size: 16px;
}
.left_menu_input /deep/ .el-input__inner {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #cccccc;
  font-size: 16px;
  line-height: 34px !important;
}

.parnterr {
  color: red !important;
}

.left_menu {
  width: 100%;
  padding: 0;
}

/deep/ .el-menu {
  border: none !important;
}
/deep/ .el-menu-item,
/deep/ .el-submenu__title {
  height: 40px;
  line-height: 40px;
  margin-bottom: 10px;
  font-size: 18px !important;
  color: #1a2332;
}
/deep/ .el-menu-item:focus,
.el-menu-item:hover {
  background-color: #e7eaed !important;
}

/deep/ .el-submenu .el-submenu__title:hover {
  background-color: #e7eaed !important;
}

/deep/ .is-active .el-submenu__title {
  font-size: 18px !important;
  color: rgb(18, 144, 201) !important;
}

/deep/ .el-submenu .el-menu-item {
  font-size: 18px !important;
  padding-left: 78px !important;
}

/deep/ .el-menu-item-group__title {
  padding: 0rem !important;
}

/deep/ .el-submenu__title i {
  color: #1a2332;
  margin-right: 0px;
}

/deep/ .is-active .el-submenu__title .icon,
/deep/.is-active .el-submenu__title i {
  color: rgb(18, 144, 201) !important;
}

/deep/ .el-submenu__title .icon {
  vertical-align: middle;
  width: 20px;
  text-align: center;
  font-size: 18px;
  margin-right: 10px;
}

/deep/.is-opened .el-icon-caret-right {
  transform: rotate(45deg);
  transition: transform 0.5s ease;
}

.iconBgwidthMagin {
  margin-right: 8px !important;
}
.iconBgwidth {
  width: 16px !important;
}
/deep/ .el-submenu.is-opened > .el-submenu__title .el-submenu__icon-arrow,
/deep/ .el-submenu__icon-arrow {
  display: none;
}

.activeColor {
  color: #1290c9;
}

.buttonhui /deep/ .el-submenu__title {
  opacity: 0.25 !important;
}
@media screen and (max-width: 1920px) {
  .wrap {
    width: 262px;
    padding: 7px 22px 0px 15px;
  }
  .flex_box {
    gap: 15px;
  }
  .avatar {
    height: 45px;
    width: 45px;
  }
  .avatartex {
    width: 45px;
    height: 45px;
    font-size: 20px;
    line-height: 45px;
  }
  .postiveaboust {
    position: absolute;
    right: -10px;
    top: 29px;
  }
  .account-left-right h3 {
    width: 165px;
    font-size: 16px;
    line-height: 22px;
  }
  .account-left-right h4 {
    font-size: 14px;
    line-height: 18px;
  }
  .left_menu_input /deep/ .el-input__prefix {
    font-size: 14px;
  }
  .left_menu_input /deep/ .el-input__inner {
    border-radius: 8px;
    font-size: 14px;
    line-height: 30px !important;
  }
  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    height: 36px;
    line-height: 36px;
    margin-bottom: 7px;
    font-size: 14px !important;
    padding-left: 0px !important;
  }
  /deep/ .is-active .el-submenu__title {
    font-size: 14px !important;
  }
  /deep/ .el-submenu .el-menu-item {
    font-size: 14px !important;
    padding-left: 60px !important;
  }
  /deep/ .el-submenu__title .icon {
    margin-right: 7px;
    width: 16px;
    font-size: 14px;
  }
  .iconBgwidthMagin {
    margin-right: 6px !important;
  }
  .iconBgwidth {
    width: 14px !important;
  }
}
@media screen and (max-width: 1441px) {
  .wrap {
    padding: 6px 20px 0px 12px;
  }
  .flex_box {
    gap: 12px;
  }
  .left_menu_input {
    padding: 0;
  }
  .account-left-right h3 {
    width: 165px;
    font-size: 16px;
    line-height: 22px;
  }
  .account-left-right h4 {
    font-size: 14px;
    line-height: 18px;
  }
  .left_menu_input /deep/ .el-input__prefix {
    font-size: 14px;
  }
  .left_menu_input /deep/ .el-input__inner {
    border-radius: 6px;
    font-size: 14px;
    line-height: 28px !important;
    padding: 0;
  }

  /deep/ .el-menu-item,
  /deep/ .el-submenu__title {
    height: 32px;
    line-height: 32px;
    margin-bottom: 6px;
    font-size: 14px !important;
    padding-left: 0px !important;
  }
  /deep/ .el-submenu__title .icon {
    margin-right: 6px;
    width: 16px;
    font-size: 14px;
  }
  .iconBgwidthMagin {
    margin-right: 5px !important;
  }
  /deep/ .left_menu,
  .left_menu_input {
    padding: 0;
  }
}
</style>
